const DESCRIBES_SCREEN_CONTENTS =
  /\b(?:see(?:ing)? everything|see(?:ing)? (?:the |your )?screen|(?:on|across) (?:the |your )?(?:whole|entire) screens?|screenshot of|unrelated windows?|same desktop concurrently)\b/i;

const MAX_USER_FACING_ERROR_CHARS = 180;

/** Keep short operational errors; replace blank, long, or screen-describing dumps. */
export const toUserFacingComputerUseErrorReason = (
  reason: string,
  fallback: string
): string => {
  const trimmed = reason.trim();
  if (!trimmed) return fallback;
  if (trimmed.length > MAX_USER_FACING_ERROR_CHARS) return fallback;
  if (DESCRIBES_SCREEN_CONTENTS.test(trimmed)) return fallback;
  return trimmed;
};
